// Wedding Configuration

export const WEDDING_CONFIG = {
  // RSVP settings
  RSVP_DEADLINE: '2026-10-03', // Guests can update until this date (3 weeks before wedding)
  
  // Admin page colors
  COLORS: {
    PRIMARY: '#7d688f',   // Purple - main headings
    SECONDARY: '#a5bc8a'  // Green - subheadings
  }
};
